export enum CHAT_AGENT_HOST {
  PRD = 'prdelorachatstg',
  SBX = 'sbxelorachatstg',
}
